import WrappedAllRoute from './route/AllRouteWrapper';
import { setToken } from './store/authSlice';
import AuthService from './services/authService';
import store from './store/store';

const token = AuthService.getAccessToken();
if (token) {
  store.dispatch(setToken(token));
}
export default function App() {
  return (
    <div>
      <WrappedAllRoute />
    </div>
  );
}
